import { TextField, Grid } from '@mui/material';

const SearchField = ({ value, onChange, placeholder, width = '50%' }) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
      <Grid sx={{ width: { xs: '100%', md: width } }}>
        <TextField
          fullWidth
          label="Search"
          variant="outlined"
          value={value}
          onChange={onChange}
          size="small"
          placeholder={placeholder}
        />
      </Grid>
    </Grid>
  );
};

export default SearchField; 